import React from 'react';
import { FaCopyright } from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-950 text-gray-400 py-6 px-4 md:px-8 text-sm flex flex-col items-center md:flex-row md:justify-between border-t border-gray-800 w-full relative z-0">
      <div className="flex items-center space-x-2">
        <span className="font-semibold text-gray-200">OSORIO NET CO</span>
        <FaCopyright className="text-yellow-500" />
      </div>
      <div className="text-center text-xs md:text-left mt-2 md:mt-0">
        {currentYear} · Todos los derechos reservados
      </div>
      <div className="text-right mt-2 md:mt-0">
        <span className="bg-gray-800 px-2 py-1 rounded text-xs text-gray-500">V2.15</span>
      </div>
    </footer>
  );
};

export default Footer;
